import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "components/pages/portfolio/insDeletePortfolioAction.scss";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { doExport } from "components/pages/administration/cashflow-forecast/insCashflowExportButton";
import { useCustomGetCashFlowCustomModelById } from "hooks/administration/use-cashflow-custom-models";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsCashflowExportDialogAction = () => {
    const { cashflowCustomModel: model } = useCustomGetCashFlowCustomModelById(), exportedToExcel = useSelector((s) => s.entities?.CashflowFile?.[model?.id ?? "content"]);
    const dispatch = useDispatch();
    return useMemo(() => React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { className: "insDeletePortfolioAction_customFooterButton hydrated", label: language.en.administration.cashflowForecasting.customModels.userModelInspection.exportWithoutChanges, type: AuxButtonTypeEnum.PRIMARY, onClick: () => {
                doExport(model, exportedToExcel, dispatch);
                dispatch(closeDialog());
            } }),
        React.createElement(CloseDialogButton, null)), [dispatch, exportedToExcel, model]);
};
